<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Subscription Hinzufügen</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" style="" >

       <div class="row">
         <div class="col">
           <div class="form-floating mb-3">
             <input type="text"  class="form-control" id="Name"  [(ngModel)]="request.name">
             <label for="Name">Name</label>
           </div>

         </div>
       </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text"  class="form-control" id="url"  [(ngModel)]="request.url">
        <label for="url">Url</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <select class="form-select "
                id="Status"
                [(ngModel)]="request.type" (ngModelChange)="request.type = $event">
          <option *ngFor="let item of Endpoints" [ngValue]="item.key">
            {{ item.Bezeichnung }}
          </option>
        </select>
        <label for="type">Endpunkt</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col" >
    <edit-subscription-partner [(ids)]="request.partnerIds"></edit-subscription-partner>
    </div>
  </div>
<div class="row">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-primary" (click)="SendNew()">Speichern</div>
  </div>
</div>
</div>


<ng-template #successVerTpl> Aktion erfolgreich! </ng-template>
<ng-template #FaildVerTpl> Aktion fehlgeschlagen! </ng-template>
